import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M12 2C6.4286 2 2 6.4286 2 12s4.4286 10 10 10 10-4.4286 10-10S17.5714 2 12 2zm-.2223 9.7798h3.1301v4.0907c-.5073.1655-.9849.2816-1.4328.3481a9.333 9.333 0 01-1.3735.0999c-1.1909 0-2.1002-.35-2.728-1.0497-.6279-.6998-.9418-1.7045-.9418-3.0141 0-1.2737.3643-2.2667 1.0928-2.979.7286-.7124 1.7387-1.0686 3.0303-1.0686.8096 0 1.5903.1619 2.3422.4857l-.5558 1.3384c-.5757-.2878-1.1747-.4317-1.7972-.4317-.7231 0-1.3024.2428-1.7377.7285-.4354.4857-.653 1.1387-.653 1.959 0 .8564.1754 1.5103.5262 1.9618.3507.4515.8607.6773 1.53.6773.349 0 .7033-.036 1.0631-.108v-1.646h-1.4949v-1.3923z",
    fillRule: "evenodd"
  }],
  circles: []
};
var CountsTowardsGradeIcon = function CountsTowardsGradeIcon(props) {
  return renderIcon(props, iconType);
};
export { CountsTowardsGradeIcon };